import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useBreakpoints } from "react-device-breakpoints";
import Draggable from "react-draggable";
import {
  FaFacebook,
  FaInstagramSquare,
  FaRegUser,
  FaTwitter,
  FaYoutube
} from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../../../assets/img/avatar.png";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import CustomModal from "../../../components/Modal";
import { SocialAddAction } from "../../../store/actions/profileAction";
import Lists from "../../home/lists";
const ViewProfile = () => {
  const dispatch = useDispatch();
  const [showProfile, setShowProfile] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalOpenText, setOpenText] = useState("");
  const handleOpen = (text) => {
    if (text === "facebook") {
      setOpenText("facebook");
      setOpen(true);
    }
    if (text === "instagram") {
      setOpenText("instagram");
      setOpen(true);
    }
    if (text === "twitter") {
      setOpenText("twitter");
      setOpen(true);
    }
    if (text === "youtube") {
      setOpenText("youtube");
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);
  const link = useSelector((state) => state.socialLink.socialLink);
  const [data, setData] = useState({
    instagram: link.instagram,
    facebook: link.facebook,
    twitter: link.twitter,
    youtube: link.youtube,
  });
  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(SocialAddAction(data));
  };
  const planList = useSelector((state) => state.listMyPlan.listMyPlan);
  // device breakpoints
  const device = useBreakpoints();
  useEffect(() => {
    if (!device.isPortraitTablet) {
      setShowProfile(false);
    }
  }, [device.isPortraitTablet]);
  return (
    <>
      <Header />
      <div className="viewprofile_page_wrapper">
        <div className="container">
          <div className="profile_containers">
            <div className="section_title">
              <h2>Profile</h2>
            </div>
            <div className="profile_info">
              <div
                className={`left_content ${showProfile ? "show_profile" : ""}`}
              >
                {device.isPortraitTablet && (
                  <div className="close_element mb-3 d-flex justify-content-between align-items-center">
                    <h2
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        textTransform: "capitalize",
                      }}
                    >
                      profile
                    </h2>
                    <h3
                      onClick={() => setShowProfile(false)}
                      style={{ fontSize: "20px", fontWeight: "600",cursor: "pointer" }}
                      className="text-danger"
                    >
                      X
                    </h3>
                  </div>
                )}

                <div className="image">
                  <img src={avatar} alt="avatar" />
                </div>
                <div className="profile_content">
                  <div className="name">
                    <h4>Abul Bashar</h4>
                  </div>
                  <div className="bio">
                    <label htmlFor="bio">Bio</label>
                    <textarea
                      name="bio"
                      placeholder="Write your bio"
                      className="form-control"
                      cols="30"
                      rows="10"
                    ></textarea>
                  </div>
                  <div className="email">
                    <h5>triplewsols.bashar@gmail.com</h5>
                  </div>
                  <div className="gender">
                    <select name="gender">
                      <option value="1">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="social_link">
                    <span>Follow Me</span>
                    <div className="link">
                      <p>
                        <FaFacebook color="#3b5998" />
                        {link.facebook ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={link.facebook}
                          >
                            Follow Me
                          </a>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleOpen("facebook")}
                            className="glow neon"
                          >
                            Add Link
                          </button>
                        )}
                      </p>
                      <p>
                        <FaInstagramSquare color="#fb3958" />
                        {link.instagram ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={link.instagram}
                          >
                            Follow Me
                          </a>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleOpen("instagram")}
                            className="glow neon"
                          >
                            Add Link
                          </button>
                        )}
                      </p>
                      <p>
                        <FaTwitter color="#00acee" />
                        {link.twitter ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={link.twitter}
                          >
                            Follow Me
                          </a>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleOpen("twitter")}
                            className="glow neon"
                          >
                            Add Link
                          </button>
                        )}
                      </p>
                      <p>
                        <FaYoutube color="#FF0000" />
                        {link.youtube ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={link.youtube}
                          >
                            Follow Me
                          </a>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handleOpen("youtube")}
                            className="glow neon"

                          >
                            Add Link
                          </button>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="update_btn">
                    <button type="button" className="glow neon btn">
                      update
                    </button>
                  </div>
                </div>
              </div>
              <div className="right_content">
                <div className="title">
                  <h2>
                    No. Of Plans&nbsp;
                    <Badge pill bg="primary">
                      {planList?.length}
                    </Badge>
                  </h2>
                </div>
                <div className="plans">
                  {planList.length > 0 ? (
                    planList.map((item) => (
                      <Lists key={item._id} editable={true} item={item} />
                    ))
                  ) : (
                    <div
                      className="empty"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "200px",
                      }}
                    >
                      {" "}
                      <h3>No Plan Here...</h3>{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!device.isPortraitTablet && showProfile && (
          <div
            className="backdrop_effect"
            onClick={() => setShowProfile(false)}
          ></div>
        )}
        {device.isPortraitTablet && (
          <Draggable bounds="body">
            <div
              className="filter_btn"
              id="filter_btn"
              onTouchStart={() => setShowProfile(true)}
              onClick={() => setShowProfile(true)}
              // onDragLeave={onDragLeav}
            >
              <h3>
                <FaRegUser />
              </h3>
            </div>
          </Draggable>
        )}
      </div>

      <CustomModal open={open} handleClose={handleClose} className="preview_modal">
        <form onSubmit={handleSubmit}>
          {modalOpenText === "facebook" && (
            <div className="form_group">
              <label htmlFor="facebook">Facebook</label>
              <input
                type="text"
                placeholder="Enter your facebook profile link"
                name="facebook"
                className="input"
                onChange={handleChange}
                value={data.facebook}
              />
            </div>
          )}
          {modalOpenText === "instagram" && (
            <div className="form_group">
              <label htmlFor="instagram">Instagram</label>
              <input
                type="text"
                placeholder="Enter your instagram profile link"
                name="instagram"
                className="input"
                onChange={handleChange}
                value={data.instagram}
              />
            </div>
          )}

          {modalOpenText === "twitter" && (
            <div className="form_group">
              <label htmlFor="twitter">Twitter</label>
              <input
                type="text"
                placeholder="Enter your twitter profile link"
                name="twitter"
                className="input"
                onChange={handleChange}
                value={data.twitter}
              />
            </div>
          )}
          {modalOpenText === "youtube" && (
            <div className="form_group">
              <label htmlFor="youtube">YouTube</label>
              <input
                type="text"
                placeholder="Enter your youtube profile link"
                name="youtube"
                className="input"
                onChange={handleChange}
                value={data.youtube}
              />
            </div>
          )}
          <div className="form_group">
            <button type="submit" className="glow neon">Add</button>
          </div>
        </form>
      </CustomModal>
      <Footer />
    </>
  );
};

export default ViewProfile;
